import React, { useEffect, useMemo, useState } from 'react';

import Box from '@mui/material/Box';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';
import Button from '../shared/Button';

import { userRoles } from '../../constants';

const FilterSurgeonsModal = (props) => {
  const {
    filter,
    open,
    onSubmit,
    onClose,
    surgeons,
    distributors = [],
    companies = [],
    currentUser,
  } = props;

  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedDistributors, setSelectedDistributors] = useState([]);

  useEffect(() => {
    if (filter) {
      setSelectedCompanies(filter.companies || []);
      setSelectedCountries(filter.countries || []);
      setSelectedDistributors(filter.distributors || []);
    }
  }, [open, filter, surgeons]);

  const onClear = () => {
    setSelectedCompanies([]);
    setSelectedCountries([]);
    setSelectedDistributors([]);
  };

  const handleSubmit = () => {
    onSubmit({
      companies: selectedCompanies,
      countries: selectedCountries,
      distributors: selectedDistributors,
    });
  }

  const countries = useMemo(() => {
    if (!selectedCompanies?.length) {
      return [];
    }

    if (currentUser.role === userRoles.COUNTRY_ADMIN.name) {
      return currentUser?.administrationCountries || [];
    }

    const result = [];
    selectedCompanies.forEach((comp) => {
      comp?.countries.forEach((country) => {
        if (!result.includes(country)) {
          result.push(country);
        }
      });
    });

    return result;
  }, [selectedCompanies, currentUser]);

  const distributorsOptions = useMemo(() => {
    if (currentUser.role === userRoles.DISTRIBUTOR_ADMIN.name) {
      return currentUser?.distributors || [];
    }

    return distributors;
  }, [distributors, currentUser]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Filter Surgeons"
      subtitle="Apply filters to find specific surgeons"
      submitText="Submit"
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' }, maxWidth: '560px' }}>
        <Box>
          <Autocomplete
            value={selectedCompanies}
            onChange={setSelectedCompanies}
            getOptionLabel={(option) => option.name}
            options={companies}
            label="Company"
            multiple
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <Autocomplete
            value={selectedCountries}
            onChange={setSelectedCountries}
            options={countries}
            label="Country"
            multiple
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <Autocomplete
            value={selectedDistributors}
            onChange={setSelectedDistributors}
            options={distributorsOptions}
            getOptionLabel={(option) => option.name}
            label="Distributors"
            multiple
          />
        </Box>
        <Button
          sx={{ mt: 2 }}
          text="Clear Filters"
          icon={<FilterAltOffOutlinedIcon />}
          onClick={onClear}
          type='secondary'
        />
      </Box>
    </Drawer>
  );
};

export default FilterSurgeonsModal;
